import React from 'react';
import PropTypes from 'prop-types';
import HorizontalRule from '@spothero/ui/horizontal-rule';
import RangeSlider from '@spothero/ui/range-slider';

const PriceRange = ({
    low,
    high,
    current,
    onAfterChange
}) => {
    return (
        <div className="PriceRange">
            <HorizontalRule />
            <span className="filter-label price-label">Price Range</span>
            <div className="PriceRange-slider">
                <RangeSlider
                    key={Math.random()}
                    min={low}
                    minLabel={`$${low}`}
                    max={high}
                    maxLabel={`$${high}`}
                    currentLabelPrefix="$"
                    defaultValue={current}
                    onAfterChange={onAfterChange}
                />
            </div>
        </div>
    );
};

PriceRange.propTypes = {
    low: PropTypes.number.isRequired,
    high: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    onAfterChange: PropTypes.func.isRequired
};

export default PriceRange;
